import { render } from "./LoadingPage.vue?vue&type=template&id=91c4114a&scoped=true"
import script from "./LoadingPage.vue?vue&type=script&lang=js"
export * from "./LoadingPage.vue?vue&type=script&lang=js"

import "./LoadingPage.vue?vue&type=style&index=0&id=91c4114a&scoped=true&lang=css"

import exportComponent from "E:\\PhpstormProjects\\cinnet_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91c4114a"]])

export default __exports__